import type { MessengerLikeLikerPreview } from '@/api/client';
import { messengerLikeInitials } from '@/utils/messengerLikeInitials';
import './MessageLikeAvatar.css';

export type MessageLikeAvatarProps = {
  liker: MessengerLikeLikerPreview;
  variant: 'own' | 'peer';
  /** Чем больше, тем выше слой при наложении (правее — сверху). */
  stackIndex: number;
};

export function MessageLikeAvatar({ liker, variant, stackIndex }: MessageLikeAvatarProps) {
  const url = liker.avatar_url?.trim();
  const hasPhoto = Boolean(url);
  const initials = messengerLikeInitials(liker.first_name, liker.last_name);
  const nameLabel =
    `${liker.first_name ?? ''} ${liker.last_name ?? ''}`.trim() ||
    (initials !== '?' ? initials : '');

  return (
    <span
      className={[
        'msgLikeAvatar',
        `msgLikeAvatar_${variant}`,
        hasPhoto ? 'msgLikeAvatar_photo' : 'msgLikeAvatar_initials',
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ zIndex: stackIndex + 1 }}
      title={nameLabel || undefined}
    >
      {hasPhoto ? (
        <img
          className="msgLikeAvatar__img"
          src={url}
          alt={nameLabel || 'Аватар'}
          loading="lazy"
          decoding="async"
        />
      ) : (
        <span className="msgLikeAvatar__initials">{initials}</span>
      )}
    </span>
  );
}
